<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        ポリシー
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">ポリシー</a>
          </li>
      </ul>
    </div>

    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>ポリシー</strong>
              <small>チェック方式を設定</small>
              <small class="float-right">{{model.created_at | datetime}}</small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="8">
              <b-form-group v-if="model && model.policy">
                <label for="ph_policy" v-b-tooltip.hover>ポリシーの説明
                </label>
                <b-form-input type="text" id="ph_descrip" v-model="model.description" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover title="ページ内を移動するためのサブリンクの最大数を入力します。 余分なリンクは無視してください。 通常、1 つのページに存在するリンクが多すぎる場合は、バランスの取れた方法でチェックされないことを防ぐために、他のページに移動する前に最大のナビゲーション ページに到達することができます。 1～1,000の範囲で指定できます。">サブページリンク
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_links" :min="1" :max="1000" v-model="model.policy.links" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover title="検査サイトで確認する総ページ数。 入力した数値に達したらチェックを終了します。 1からライセンス制限までの範囲で指定できます。">最大ナビゲーションページ
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_limit" :min="10" :max="limit" v-model="model.policy.limit" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="最初のページから次のページへリンクを移動（パス）して確認するかどうかを入力します。 1～100の範囲で指定できます。">最大パス深度
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_depth" :min="1" :max="100" v-model="model.policy.depth" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover title="ページの読み込みを待つ時間。 1～30の範囲で指定できます。">タイムアウト(秒)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_timeout" :min="1" :max="30" v-model="model.policy.timeout" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover title="新しいページに移動するまでの待ち時間。 1～10,000の範囲で指定できます。">チェック速度(ミリ秒)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" id="ph_delay" :min="0" :max="10000" v-model="model.policy.delay" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 復活 </b-button> -->
              <span>削除されたポリシー</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 編集 </b-button>
              <b-button size="sm" variant="danger" @click="remove"> 削除 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
        </b-card>
        <hr>
        <siteList v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
